<template>
    <div class="container" v-show="show">
        <div class="box-share">
            <div class="model"></div>
            <div class="content">
                <div class="title">{{ title }}</div>
                <div class="content-txt">{{ content }}</div>
                <div class="btn-container">
                    <div class="give-up" @click="giveupBtn">{{ lefttxt }}</div>
                    <div class="continue" @click="continueBtn">{{ righttxt }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'homeTitleDialog',
    props: ['show', 'text', 'type', 'title', 'lefttxt', 'righttxt', 'content'],

    methods: {
        giveupBtn() {
            this.$emit('giveupBtn');
        },
        continueBtn() {
            this.$emit('continueBtn');
        }
    }
};
</script>
<style lang="less" scoped>
@import '~@/common/style/common.less';
.container {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    z-index: 1111;
    justify-content: center;
    align-items: center;
}
.box-share {
    z-index: 1;
    .content {
        z-index: 1;
        width: 300px;
        display: flex;
        border-radius: 8px;
        flex-direction: column;
        align-items: center;
        background-color: #fff;
        .title {
            color: #002a3c;
            .f-18-bold();
            margin-top: 30px;
        }
        .content-txt {
            margin-top: 15px;
            margin-left: 24px;
            margin-right: 24px;
            font-size: 15px;
            color: #49596c;
            line-height: 21px;
        }
        .btn-container {
            width: 100%;
            height: 51px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 30px;
            padding: 0 24px 22px;
            .give-up {
                width: 117px;
                height: 36px;
                border-radius: 8px;
                border: 1px solid #dce1e6;
                font-size: 16px;
                color: #616b78;
                text-align: center;
                font-weight: bolder;
                line-height: 36px;
            }
            .continue {
                width: 117px;
                height: 36px;
                background: linear-gradient(270deg, #3ca5e2 0%, #4dbaf9 100%);
                border-radius: 8px;
                font-size: 16px;
                font-weight: bolder;
                text-align: center;
                color: #fff;
                line-height: 36px;
            }
        }
    }
}
</style>
